import React, { useContext, useEffect, useState } from "react";
import { LoaderContext } from "../../Context/ContextFunctions";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons

import {
  AddUpdateCustomerApi,
  GetCustomerModel,
} from "../../services/Customer/CustomerApi";
import Utils from "../../middleware/Utils";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import PaperWork from "../../components/common/PaperWork";
import AndroidSwitch from "../../components/common/AndroidSwitch";
import { AuthContext } from "../../Context/ContextFunctions";
import { FaPlus, FaTrash } from "react-icons/fa";
import { ERROR_MESSAGES } from "../../components/common/GlobalMassssage";
import { Tooltip } from "@mui/material";
import { GetBusinessTypeLookupList } from "../../services/Lookuplist/BusinessTypeLookupListApi";
import { GetAdminLookupList } from "../../services/Admin/AdminApi";
import { GetCustomerIndustryLookupList } from "../../services/CustomerIndustry/CustomerIndustryApi";
import { GetServiceLookupList } from "../../services/Service/ServiceApi";
import NoResultFoundModel from "../../components/common/NoDataFound";
import { useLocation } from "react-router-dom";
import { GetCountryLookupList } from "../../services/Country/CountryApi";
import SuccessModal from "../../components/common/SuccessModal";
import ErrorModal from "../../components/common/ErrorModal";
import { GetSADesignationLookupList } from "../../services/SettingDesignation/SettingDesignationApi";

const AddUpdateCustomer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { isAddUpdateDone = false, modelRequestData = {} } =
    location.state || {};
  console.log(isAddUpdateDone, modelRequestData);

  const moduleName = "AddUpdateCustomer";
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const { validateEmail, handlePhoneNumberInput, stringifyNumber } =
    useContext(AuthContext);

  //Context
  const { setLoader } = useContext(LoaderContext);
  const { authDetails, pageSize } = useContext(AuthContext);

  const [customerObj, setCustomerObj] = useState({
    businessTypeID: null,
    accountManagerID: null,
    industryID: null,
    companyName: null,
    companyAddress: null,
    pincode: null,
    gstID: 0,
    gstNumber: null,
    firstName: null,
    lastName: null,
    phoneNumber: null,
    countryID: null,
    email: null,
    registrationAddress: null,
    birthdate: null,
    groupeID: null,
    projectName: null,
    cost: null,
    timeLine: null,
    paymentsTerms: null,
    reamark: null,
    password: null,
  });

  const [activeTab, setActiveTab] = useState(() => {
    const storedTab = Number(localStorage.getItem("selectedTab"));
    const storedPath = localStorage.getItem("CurrentPath");

    return storedPath === "/addUpdateCustomer" && storedTab ? storedTab : 1;
  });
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [selectedServices, setSelectedServices] = useState(
    Utils.servicesList.map(() => false)
  );
  const [contacts, setContacts] = useState([
    {
      firstName: "",
      lastName: "",
      designation: null,
      phoneNumber: "",
      countryID: null,
      email: "",
      altEmail: "",
    },
  ]);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const [ShowPricingModel, setShowPricingModel] = useState(false);
  const [selectedService, setSelectedService] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState([]); // Array to hold selected plans
  const [businessTypes, setBusinessTypes] = useState([]);
  const [adminOptions, setAdminOptions] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [customerIndustryOptions, setcustomerIndustryOptions] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [modelAction, setModelAction] = useState("");
  const [countryLookupList, setCountryLookupList] = useState([]);
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const [price, setPrice] = useState("");
  const [servicePrices, setServicePrices] = useState({});
  const [showServiceError, setShowServiceError] = useState(false);

  useEffect(() => {
    if (modelRequestData && modelRequestData.customerKeyID) {
      setModelAction("Update");
      GetCustomerModelData(modelRequestData.customerKeyID);
    } else {
      setModelAction("Add"); // Set to "Add" if no customerKeyID
    }
  }, [modelRequestData]);
  useEffect(() => {
    if (serviceOptions.length > 0 && modelRequestData.customerKeyID) {
      GetCustomerModelData(modelRequestData.customerKeyID);
    }
  }, [serviceOptions, modelRequestData.customerKeyID]);

  //Get Model

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // Convert to YYYY-MM-DD format
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const GetCustomerModelData = async () => {
    setLoader(true);
    const data = await GetCustomerModel(
      modelRequestData.customerKeyID,
      authDetails.adminKeyID
    ); // Pass KeyID to the API
    if (data.statusCode === 200) {
      setLoader(false);
      const ModalData = data.responseData.data;

      // Update the customerObj state with the data from the API response
      setCustomerObj({
        ...customerObj,
        customerKeyID: ModalData.customerKeyID,
        businessTypeID: ModalData.businessTypeID,
        accountManagerID: ModalData.accountManagerAdminKeyID,
        industryID: ModalData.customerIndustryID,
        companyName: ModalData.companyName,
        companyAddress: ModalData.companyAddress,
        pincode: ModalData.pincode,
        gstID: ModalData.isGSTRegistered ? 0 : 1, // Assuming 0 for Yes and 1 for No
        gstNumber: ModalData.gstNo,
        website: ModalData.website,
        firstName: ModalData.otherInfo.firstName,
        lastName: ModalData.otherInfo.lastName,
        phoneNumber: ModalData.otherInfo.mobileNo,
        email: ModalData.otherInfo.email,
        registrationAddress: ModalData.otherInfo.address,
        birthdate: formatDate(ModalData.otherInfo.birthDate),
        password: ModalData.otherInfo.password,
        countryID: ModalData.otherInfo.countryID, // Add any other fields you want to set from the response
      });
      // Set selected services based on the serviceKeyIDs
      const selectedServiceIDs = ModalData.serviceKeyIDs || [];
      const updatedSelectedServices = serviceOptions.map((service) =>
        selectedServiceIDs.includes(service.value)
      );

      setSelectedServices(updatedSelectedServices); // Update the selected services state
      setSelectedService(
        serviceOptions.filter((_, index) => updatedSelectedServices[index])
      ); // Update selectedService state
      // If you want to set the contacts from the officerList
      if (ModalData.officerList && ModalData.officerList.length > 0) {
        const formattedContacts = ModalData.officerList.map((officer) => ({
          firstName: officer.firstName,
          lastName: officer.lastName,
          designation: officer.designationID,
          phoneNumber: officer.mobileNo,
          countryID: officer.countryID,
          email: officer.email,
        }));
        setContacts(formattedContacts);
      }
    } else {
      setLoader(false);
      // Handle error case
    }
  };

  useEffect(() => {
    // Clear local storage when the component mounts
    // localStorage.clear();

    // Set the active tab to 1
    setActiveTab(1);

    // Optionally, you can return a cleanup function if needed
    return () => {
      // Any cleanup if necessary
    };
  }, []);
  useEffect(() => {
    GetBusinessTypeLookupListData();
    GetAdminLookupListData();
    GetDesignationLookupListData();
    GetCustomerIndustryLookupListData();
    GetCountryLookupListData();
  }, []);

  useEffect(() => {
    if (customerObj.industryID) {
      GetServiceLookupListData(customerObj.industryID);
    }
  }, [customerObj.industryID]); // Dependency array includes industryID
  // Tab Data
  useEffect(() => {
    localStorage.setItem("selectedTab", activeTab);
    localStorage.setItem("CurrentPath", "/addUpdateCustomer");
  }, [activeTab]);
  const tabs = [
    { id: 1, label: "Customer Information" },
    { id: 2, label: "Services" },
    // { id: 3, label: "Engagement Model" },
    { id: 4, label: "Paper Work" },
  ];

  const GetBusinessTypeLookupListData = async () => {
    try {
      let response = await GetBusinessTypeLookupList();

      console.log("API Response:", response); // Debugging step

      // Check if response contains data
      if (response?.statusCode === 200) {
        const options = response?.responseData?.data.map((item) => ({
          value: item.businessTypeID,
          label: item.businessTypeName,
        }));
        console.log("Mapped Options:", options); // Confirm correct mapping

        setBusinessTypes(options);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching market lookup list:", error);
    }
  };
  const GetAdminLookupListData = async () => {
    try {
      const adminKeyID = authDetails?.adminKeyID;
      if (!adminKeyID) return;

      let response = await GetAdminLookupList(adminKeyID);

      console.log("API Response:", response); // Debugging step

      // Check if response contains data
      if (response?.statusCode === 200) {
        const adminOption = response?.responseData?.data.map((val) => ({
          value: val.adminKeyID,
          label: val.adminName,
        }));
        console.log("Mapped Options:", adminOption); // Confirm correct mapping

        setAdminOptions(adminOption);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching market lookup list:", error);
    }
  };

  const GetDesignationLookupListData = async () => {
    try {
      const adminKeyID = authDetails?.adminKeyID;
      if (!adminKeyID) return;

      let response = await GetSADesignationLookupList(adminKeyID);

      console.log("API Response:", response); // Debugging step

      // Check if response contains data
      if (response?.statusCode === 200) {
        const designationIndustryOption = response?.responseData?.data.map(
          (val) => ({
            value: val.designationID,
            label: val.designationName,
          })
        );
        console.log("Mapped Options:", designationIndustryOption); // Confirm correct mapping

        setDesignationOptions(designationIndustryOption);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching market lookup list:", error);
    }
  };

  const GetCustomerIndustryLookupListData = async () => {
    try {
      const adminKeyID = authDetails?.adminKeyID;
      if (!adminKeyID) return;

      let response = await GetCustomerIndustryLookupList(adminKeyID);

      console.log("API Response:", response); // Debugging step

      // Check if response contains data
      if (response?.statusCode === 200) {
        const customerIndustryOption = response?.responseData?.data.map(
          (val) => ({
            value: val.customerIndustryID,
            label: val.customerIndustryName,
          })
        );
        console.log("Mapped Options:", customerIndustryOption); // Confirm correct mapping

        setcustomerIndustryOptions(customerIndustryOption);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching market lookup list:", error);
    }
  };

  const GetServiceLookupListData = async (customerIndustryID) => {
    try {
      const adminKeyID = authDetails?.adminKeyID;
      if (!adminKeyID) return;

      let response = await GetServiceLookupList(
        "Predefined",
        customerIndustryID,
        adminKeyID
      );

      console.log("API Response:", response); // Debugging step

      // Check if response contains data
      if (response?.statusCode === 200) {
        const options = response?.responseData?.data.map((item) => ({
          value: item.serviceKeyID, // Use serviceKeyID for the value
          label: item.serviceName, // Use serviceName for the label
        }));
        console.log("Mapped Options:", options); // Confirm correct mapping

        setServiceOptions(options); // Update the state with fetched services
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching service lookup list:", error);
    }
  };

  const handleCheckboxChange = (index) => {
    const updatedServices = [...selectedServices];
    updatedServices[index] = !updatedServices[index]; // Toggle selection
    setSelectedServices(updatedServices);

    const newSelectedServices = serviceOptions.filter(
      (_, i) => updatedServices[i]
    );
    setSelectedService(newSelectedServices); // Store all selected services

    if (newSelectedServices.length === 0) {
      setShowServiceError(true);
    } else {
      setShowServiceError(false);
    }
  };

  const GetCountryLookupListData = async () => {
    try {
      let response = await GetCountryLookupList();

      console.log("API Response:", response); // Debugging step

      // Check if response contains data
      if (response?.statusCode === 200) {
        const Countryoptions = response?.responseData?.data.map((item) => ({
          value: item.countryID,
          label: item.countryCode,
        }));
        console.log("Mapped Options:", Countryoptions); // Confirm correct mapping

        setCountryLookupList(Countryoptions);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching market lookup list:", error);
    }
  };

  const addContact = () => {
    setContacts([...contacts, {}]); // Add another contact form
  };
  const handleSavePrice = () => {
    setServicePrices({ ...servicePrices, [selectedService]: price });
    setShowPricingModel(false);
    setSelectedService(null);
    setSelectedPlan(null);
    setPrice("");
  };
  const handleInputChange = (index, field, value) => {
    // If the field is phoneNumber, sanitize it first
    if (field === "phoneNumber") {
      value = handlePhoneNumberInput(value);
    }

    const updatedContacts = [...contacts];
    updatedContacts[index][field] = value;

    setContacts(updatedContacts);
  };

  //Check validation
  const handleChangeNext = (tab) => {
    if (activeTab > tab) {
      setActiveTab(tab);
      return;
    }

    let hasError = false;

    if (activeTab === tabs[0].id) {
      // Validate required fields in the first tab
      if (
        !customerObj.businessTypeID ||
        !customerObj.accountManagerID ||
        !customerObj.industryID ||
        !customerObj.companyName ||
        !customerObj.companyAddress ||
        !customerObj.pincode ||
        !customerObj.firstName ||
        !customerObj.lastName ||
        !customerObj.phoneNumber ||
        !customerObj.email ||
        !customerObj.password ||
        !customerObj.countryID ||
        (customerObj.gstID === 0 && !customerObj.gstNumber) // Check GST number if registered
      ) {
        hasError = true;
        setRequireErrorMessage(true); // Show error message
      } else {
        setRequireErrorMessage(false); // Clear error message
        setActiveTab(tab); // Move to the next tab
      }
    } else if (activeTab === tabs[1].id) {
      // Validate selected services in the second tab
      if (selectedService.length === 0) {
        hasError = true;
        setRequireErrorMessage(true); // Show error message
        setShowServiceError(true); // Show error message for services tab
      } else {
        setRequireErrorMessage(false);
        setShowServiceError(false); // Clear error message for services tab
        setActiveTab(tab);
      }
    } else if (activeTab === tabs[2].id) {
      // Validate selected plans in the third tab
      if (selectedPlan.length === 0) {
        hasError = true;
        setRequireErrorMessage(true);
      } else {
        setRequireErrorMessage(false);
        setActiveTab(tab);
      }
    }

    if (hasError) {
      console.warn("Validation failed, please fill all required fields.");
    }
  };
  const handleGstChange = (e) => {
    const gst = e.target.value.toUpperCase(); // GST is typically uppercase
    setCustomerObj({
      ...customerObj,
      gstNumber: gst,
    });
  };

  const handleSubmit = async () => {
    // Perform any final validation if needed
    if (activeTab !== 4) {
      setActiveTab(4);
      return; // Prevent submission if not on the last tab
    }

    // Check if any services are selected
    if (selectedService.length === 0) {
      setRequireErrorMessage(true); // Show error message
      return; // Prevent submission
    }

    // Create the API payload
    const apiPayload = {
      customerKeyID: customerObj.customerKeyID,
      adminKeyID: authDetails.adminKeyID,
      businessTypeID: customerObj.businessTypeID,
      accountManagerAdminKeyID: customerObj.accountManagerID,
      customerIndustryID: customerObj.industryID,
      companyName: customerObj.companyName,
      companyAddress: customerObj.companyAddress,
      pincode: customerObj.pincode,
      isGSTRegistered: customerObj.gstID === 0,
      gstNo: customerObj.gstNumber,
      website: customerObj.website,
      otherInfo: {
        officerKeyID: customerObj.officerKeyID,
        firstName: customerObj.firstName,
        lastName: customerObj.lastName,
        designationID: contacts[0]?.designation,
        countryID: Number(customerObj.countryID), // Ensure countryID is included and is an integer
        mobileNo: customerObj.phoneNumber,
        email: customerObj.email,
        address: customerObj.registrationAddress,
        birthDate: customerObj.birthdate,
        password: customerObj.password,
      },
      officerList: contacts.map((contact) => ({
        officerKeyID: contact.officerKeyID,
        firstName: contact.firstName,
        lastName: contact.lastName,
        designationID: contact.designation,
        countryID: contact.countryID ? Number(contact.countryID) : null, // Set to null if countryID is not valid
        mobileNo: contact.phoneNumber,
        email: contact.email,
        address: contact.address,
        birthDate: contact.birthDate,
        password: contact.password,
      })),
      serviceKeyIDs: selectedService
        .map((service) => service.value)
        .filter(Boolean), // Filter out any falsy values
    };

    console.log("API Payload:", JSON.stringify(apiPayload)); // Debugging

    // Show loader
    setLoader(true);

    setLoader(true);

    try {
      // Call the AddUpdateCustomer API
      const response = await AddUpdateCustomerApi(apiPayload);

      // Handle the response
      if (response?.statusCode === 200) {
        setShowSuccessPopupModal(true); // Show success modal
      } else {
        setIsErrorOpen(true);
      }
    } catch (error) {
      console.error("API call failed:", error);
    } finally {
      setLoader(false); // Hide loader after API call
    }
  };
  const urlRegex = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(:\d+)?(\/.*)?$/i;
  return (
    <>
      <div className="bg-gray-50 mx-auto rep-width p-6">
        <div className="h-full bg-white shadow rounded-lg flex flex-col px-6">
          {/* Header Section */}
          <h2 className="text-16 font-semibold mb-6">
            {modelAction === "Update"
              ? "Update Customer"
              : "Create New Customer"}
          </h2>
          {/* Tabs */}
          <div className="flex flex-wrap justify-center gap-8 sm:gap-4 md:gap-10 lg:gap-[130px] mb-8">
            {tabs.map((tab) => (
              <div key={tab.id} className="flex flex-col items-center">
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-full cursor-pointer text-12   font-semibold
                    ${
                      activeTab === tab.id
                        ? "bg-[#E86B1B] text-white"
                        : "bg-gray-300 text-black"
                    }`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  ✔
                </div>
                <span
                  className={`mt-2 text-12 text-12 ${
                    activeTab === tab.id ? "text-[#E86B1B]" : "text-gray-500"
                  }`}
                >
                  {tab.label}
                </span>
              </div>
            ))}
          </div>
          {/* Dynamic Content Based on Active Tab */}
          {activeTab === 1 && (
            <>
              <div className="text-12 bg-white shadow-lg ring-1 ring-gray-300 rounded-2xl p-6 mb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Customer Type <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      className="w-full"
                      value={
                        businessTypes.find(
                          (item) => item.value === customerObj.businessTypeID
                        ) || null
                      }
                      onChange={(e) =>
                        setCustomerObj({
                          ...customerObj,
                          businessTypeID: e.value,
                        })
                      }
                      options={businessTypes}
                    />
                    {requireErrorMessage && !customerObj.businessTypeID && (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    )}
                  </div>
                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Account Manager <span style={{ color: "red" }}>*</span>
                    </label>
                    {adminOptions.length > 0 ? (
                      <Select
                        className="w-full"
                        value={
                          adminOptions.find(
                            (item) =>
                              item.value === customerObj.accountManagerID
                          ) || null
                        }
                        onChange={(e) =>
                          setCustomerObj({
                            ...customerObj,
                            accountManagerID: e.value,
                          })
                        }
                        options={adminOptions}
                      />
                    ) : (
                      ""
                    )}
                    {requireErrorMessage &&
                    (customerObj.accountManagerID === "" ||
                      customerObj.accountManagerID === undefined ||
                      customerObj.accountManagerID === null) ? (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="bg-white shadow-lg ring-1 ring-gray-300 rounded-2xl p-6 mb-6">
                <h3 className="text-12   font-semibold  mb-2 mt-3">
                  Customer Information
                </h3>
                <div className=" text-12 grid grid-cols-1 md:grid-cols-4 gap-4">
                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Industry <span className="text-red-500">*</span>
                    </label>
                    <Select
                      options={customerIndustryOptions}
                      value={
                        customerIndustryOptions.find(
                          (option) => option.value === customerObj.industryID
                        ) || null
                      }
                      onChange={(e) => {
                        setCustomerObj({
                          ...customerObj,
                          industryID: e.value,
                        });
                        GetServiceLookupListData(e.value); // Call the service lookup with the selected industry ID
                      }}
                      className="w-full text-12"
                      classNamePrefix="react-select"
                    />
                    {requireErrorMessage &&
                    (customerObj.industryID === "" ||
                      customerObj.industryID === undefined ||
                      customerObj.industryID === null) ? (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Company Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Customer Company Name"
                      value={customerObj.companyName}
                      onChange={(e) =>
                        setCustomerObj({
                          ...customerObj,
                          companyName: e.target.value,
                        })
                      }
                      className="w-full p-2 border rounded-md text-12 "
                    />
                    {requireErrorMessage &&
                    (customerObj.companyName === "" ||
                      customerObj.companyName === undefined ||
                      customerObj.companyName === null) ? (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      {" "}
                      Company Address <span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      placeholder="Enter Customer Company Address"
                      className="w-full p-2 border rounded-md text-12"
                      value={customerObj.companyAddress}
                      onChange={(e) =>
                        setCustomerObj({
                          ...customerObj,
                          companyAddress: e.target.value,
                        })
                      }
                    ></textarea>
                    {requireErrorMessage &&
                    (customerObj.companyAddress === "" ||
                      customerObj.companyAddress === undefined ||
                      customerObj.companyAddress === null) ? (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Pincode <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text" // Keep it as text to allow maxLength restriction
                      placeholder="Pincode"
                      value={customerObj.pincode}
                      maxLength={6}
                      onChange={(e) => {
                        const newPincode = e.target.value;

                        // Allow only digits
                        if (/^\d*$/.test(newPincode)) {
                          setCustomerObj({
                            ...customerObj,
                            pincode: newPincode,
                          });
                        }
                      }}
                      className="w-full p-2 border rounded-md text-12"
                    />

                    {requireErrorMessage &&
                    (customerObj.pincode === "" ||
                      customerObj.pincode === undefined ||
                      customerObj.pincode === null) ? (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    ) : null}
                  </div>
                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      GST Registered
                    </label>
                    <div className="flex items-center space-x-4">
                      <label className="flex items-center space-x-2">
                        <input
                          type="radio"
                          name="gstRegistered"
                          value={0}
                          checked={customerObj.gstID === 0}
                          onChange={(e) =>
                            setCustomerObj({
                              ...customerObj,
                              gstID: Number(e.target.value), // Convert string to number
                            })
                          }
                          className="accent-blue-500"
                        />
                        <span className="text-12 text-gray-700">Yes</span>
                      </label>
                      <label className="flex items-center space-x-2">
                        <input
                          type="radio"
                          name="gstRegistered"
                          value={1}
                          checked={customerObj.gstID === 1}
                          onChange={(e) =>
                            setCustomerObj({
                              ...customerObj,
                              gstID: Number(e.target.value), // Convert string to number
                            })
                          }
                          className="accent-blue-500"
                        />
                        <span className="text-12 text-gray-700">No</span>
                      </label>
                    </div>
                  </div>

                  {customerObj.gstID === 0 && (
                    <div>
                      <label className="block text-gray-700 text-12 mb-1">
                        GST Number<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="GST Number"
                        value={customerObj.gstNumber}
                        onChange={(e) => handleGstChange(e)}
                        className="w-full p-2 border rounded-md text-12"
                        maxLength={20}
                      />
                      {requireErrorMessage && customerObj.gstID === 0 && (
                        <>
                          {customerObj.gstNumber === "" ||
                          customerObj.gstNumber === undefined ||
                          customerObj.gstNumber === null ? (
                            <label className="validation">
                              {ERROR_MESSAGES}
                            </label>
                          ) : !gstRegex.test(customerObj.gstNumber) ? (
                            <label className="validation">
                              Invalid GST Number
                            </label>
                          ) : null}
                        </>
                      )}
                    </div>
                  )}
                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Website
                    </label>
                    <input
                      type="text"
                      placeholder="Website"
                      value={customerObj.website}
                      onChange={(e) => {
                        const newWebsite = e.target.value;
                        setCustomerObj({
                          ...customerObj,
                          website: newWebsite,
                        });
                      }}
                      className="w-full p-2 border rounded-md text-12"
                    />
                    {requireErrorMessage &&
                      customerObj.website &&
                      !urlRegex.test(customerObj.website) && (
                        <label className="validation">
                          Invalid Website URL
                        </label>
                      )}
                  </div>
                </div>
                {/* Other Information */}
                <h3 className="text-12   font-semibold mb-2 mt-3">
                  Other Information
                </h3>
                <div className="text-12 grid grid-cols-1 md:grid-cols-4 gap-4">
                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      First Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="First Name"
                      value={customerObj.firstName}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Check if the input matches the desired pattern
                        if (
                          /^[A-Za-z][A-Za-z\s]*$/.test(value) ||
                          value === ""
                        ) {
                          if (value.length <= 30) {
                            // Capitalize the first letter and keep the rest of the string
                            const capitalizedValue =
                              value.charAt(0).toUpperCase() +
                              value.slice(1).toLowerCase();
                            setCustomerObj({
                              ...customerObj,
                              firstName: capitalizedValue,
                            });
                          }
                        }
                      }}
                      className="w-full p-2 border rounded-md text-12"
                    />
                    {requireErrorMessage &&
                    (customerObj.firstName === "" ||
                      customerObj.firstName === undefined ||
                      customerObj.firstName === null) ? (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    ) : null}
                  </div>

                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Last Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Last Name"
                      value={customerObj.lastName}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Check if the input matches the desired pattern
                        if (
                          /^[A-Za-z][A-Za-z\s]*$/.test(value) ||
                          value === ""
                        ) {
                          if (value.length <= 30) {
                            // Capitalize the first letter and keep the rest of the string
                            const capitalizedValue =
                              value.charAt(0).toUpperCase() +
                              value.slice(1).toLowerCase();
                            setCustomerObj({
                              ...customerObj,
                              lastName: capitalizedValue,
                            });
                          }
                        }
                      }}
                      className="w-full p-2 border rounded-md text-12"
                    />
                    {requireErrorMessage &&
                    (customerObj.lastName === "" ||
                      customerObj.lastName === undefined ||
                      customerObj.lastName === null) ? (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    ) : null}
                  </div>
                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Phone <span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center border border-gray-300 rounded-md max-w-md">
                      <div className="w-1/4">
                        <Select
                          className="w-full"
                          options={countryLookupList} // Use the fetched country options
                          value={
                            countryLookupList.find(
                              (option) => option.value === customerObj.countryID
                            ) || null
                          }
                          onChange={(e) =>
                            setCustomerObj({
                              ...customerObj,
                              countryID: e.value,
                            })
                          }
                          placeholder="Select"
                        />
                      </div>
                      <div className="w-3/4 pl-2">
                        <input
                          type="text"
                          className="w-full p-2 border-l border-gray-300 focus:outline-none"
                          placeholder="Enter phone number"
                          value={customerObj.phoneNumber || ""}
                          onChange={(e) => {
                            const validPhoneNumber = handlePhoneNumberInput(
                              e.target.value
                            );
                            setCustomerObj({
                              ...customerObj,
                              phoneNumber: validPhoneNumber,
                            });
                          }}
                        />
                      </div>
                    </div>

                    {requireErrorMessage &&
                    (customerObj.phoneNumber === "" ||
                      customerObj.phoneNumber === undefined ||
                      customerObj.phoneNumber === null ||
                      customerObj.countryID === "" ||
                      customerObj.countryID === undefined ||
                      customerObj.countryID === null) ? (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    ) : customerObj.phoneNumber?.length < 10 ? (
                      <label className="validation">Invalid Number</label>
                    ) : (
                      ""
                    )}
                  </div>

                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Email <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Email"
                      className="w-full p-2 border rounded-md text-12"
                      value={customerObj.email || ""}
                      onChange={(e) =>
                        setCustomerObj({
                          ...customerObj,
                          email: e.target.value,
                        })
                      }
                    />
                    {requireErrorMessage &&
                    (customerObj.email === "" ||
                      customerObj.email === undefined ||
                      customerObj.email === null) ? (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    ) : (
                      (customerObj.email || "").length > 0 &&
                      !validateEmail(customerObj.email) && (
                        <label className="validation text-red-500 text-sm">
                          Invalid email format
                        </label>
                      )
                    )}
                  </div>
                  {/* <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Residential Address{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      placeholder="Enter Residential Address"
                      className="w-full p-2 border rounded-md text-12"
                      value={customerObj.registrationAddress || ""} // Ensure it's controlled
                      onChange={(e) =>
                        setCustomerObj({
                          ...customerObj,
                          registrationAddress: e.target.value,
                        })
                      }
                    />
                    {requireErrorMessage &&
                    (customerObj.registrationAddress === "" ||
                      customerObj.registrationAddress === undefined ||
                      customerObj.registrationAddress === null) ? (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    ) : (
                      ""
                    )}
                  </div> */}

                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Birth Date
                    </label>
                    <input
                      type="date"
                      className="w-full p-2 border rounded-md text-12"
                      value={customerObj.birthdate || ""}
                      // Allow only dates up to 18 years ago
                      max={
                        new Date(
                          new Date().setFullYear(new Date().getFullYear() - 18)
                        )
                          .toISOString()
                          .split("T")[0]
                      }
                      onChange={(e) =>
                        setCustomerObj({
                          ...customerObj,
                          birthdate: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 text-12 mb-1">
                      Password <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="relative">
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        placeholder="Password"
                        value={customerObj.password}
                        maxLength={20}
                        onChange={(e) =>
                          setCustomerObj({
                            ...customerObj,
                            password: e.target.value,
                          })
                        }
                        className="w-full p-2 border rounded-md text-12 "
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute right-2 top-1/2 transform -translate-y-1/2"
                      >
                        {isPasswordVisible ? (
                          <FaEyeSlash className="text-gray-500" />
                        ) : (
                          <FaEye className="text-gray-500" />
                        )}
                      </button>
                    </div>
                    {requireErrorMessage && !customerObj.password && (
                      <label className="validation">{ERROR_MESSAGES}</label>
                    )}
                    {customerObj.password &&
                      customerObj.password.length < 8 && (
                        <label className="validation">
                          Password must be at least 8 characters long.
                        </label>
                      )}
                  </div>
                </div>
                {/* Contact Information */}
              </div>
              {customerObj.businessTypeID !== 1 && (
                <div className="bg-white shadow-lg ring-1 ring-gray-300 rounded-2xl p-6 mb-6">
                  {/* Toggle Button */}
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-12   font-semibold">
                      Contact Information
                    </h3>
                    <div className="flex justify-end">
                      <Tooltip title="Add Contact">
                        <button
                          onClick={addContact}
                          className="text-white bg-[#E86B1B] rounded-md p-2 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                        >
                          <FaPlus size={12} />
                        </button>
                      </Tooltip>
                    </div>
                  </div>

                  {/* Show contact form only when toggle is ON */}

                  {contacts.map((contact, index) => (
                    <div
                      key={index}
                      className="border border-gray-300 rounded-lg p-4 mb-4 text-12"
                    >
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-0 bg-gray-100 px-4 py-3 rounded-md mb-4 shadow-sm border border-gray-200">
                        <span className="text-gray-800 font-semibold text-sm sm:text-base">
                          {index === 0
                            ? "First Contact"
                            : `${stringifyNumber(index + 1)} Contact`}
                        </span>

                        {index > 0 && (
                          <button
                            className="text-gray-500  transition duration-200 self-end sm:self-auto"
                            onClick={() =>
                              setContacts(
                                contacts.filter((_, i) => i !== index)
                              )
                            }
                          >
                            <FaTrash className="text-lg" />
                          </button>
                        )}
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div>
                          <label className="block text-gray-700 text-12 mb-1">
                            First Name <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="First Name"
                            value={contact.firstName}
                            onChange={(e) => {
                              const value = e.target.value;

                              // Check if the input matches the desired pattern
                              if (
                                /^[A-Za-z][A-Za-z\s]*$/.test(value) ||
                                value === ""
                              ) {
                                if (value.length <= 30) {
                                  // Capitalize the first letter and keep the rest of the string
                                  const capitalizedValue =
                                    value.charAt(0).toUpperCase() +
                                    value.slice(1).toLowerCase();
                                  handleInputChange(
                                    index,
                                    "firstName",
                                    capitalizedValue
                                  );
                                }
                              }
                            }}
                            className="w-full p-2 border rounded-md text-12"
                          />
                          {requireErrorMessage &&
                          (contact.firstName === "" ||
                            contact.firstName === undefined ||
                            contact.firstName === null) ? (
                            <label className="validation">
                              {ERROR_MESSAGES}
                            </label>
                          ) : null}
                        </div>

                        <div>
                          <label className="block text-gray-700 text-12 mb-1">
                            Last Name <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Last Name"
                            value={contact.lastName}
                            onChange={(e) => {
                              const value = e.target.value;

                              // Check if the input matches the desired pattern
                              if (
                                /^[A-Za-z][A-Za-z\s]*$/.test(value) ||
                                value === ""
                              ) {
                                if (value.length <= 30) {
                                  // Capitalize the first letter and keep the rest of the string
                                  const capitalizedValue =
                                    value.charAt(0).toUpperCase() +
                                    value.slice(1).toLowerCase();
                                  handleInputChange(
                                    index,
                                    "lastName",
                                    capitalizedValue
                                  );
                                }
                              }
                            }}
                            className="w-full p-2 border rounded-md text-12"
                          />
                          {requireErrorMessage &&
                          (contact.lastName === "" ||
                            contact.lastName === undefined ||
                            contact.lastName === null) ? (
                            <label className="validation">
                              {ERROR_MESSAGES}
                            </label>
                          ) : null}
                        </div>

                        <div>
                          <label className="block text-gray-700 text-12 mb-1">
                            Designation <span className="text-red-500">*</span>
                          </label>
                          <Select
                            className="w-full"
                            options={designationOptions} // Use designationOptions here
                            value={
                              designationOptions.find(
                                (item) => item.value === contact.designation
                              ) || null
                            }
                            onChange={(selected) =>
                              handleInputChange(
                                index,
                                "designation",
                                selected.value
                              )
                            }
                          />
                          {requireErrorMessage &&
                          (contact.designation === "" ||
                            contact.designation === undefined ||
                            contact.designation === null) ? (
                            <label className="validation">
                              {ERROR_MESSAGES}
                            </label>
                          ) : (
                            ""
                          )}
                        </div>

                        <div>
                          <label className="block text-gray-700 text-12 mb-1">
                            Phone <span className="text-red-500">*</span>
                          </label>
                          <div className="flex items-center border border-gray-300 rounded-md max-w-md">
                            <Select
                              className="w-24 sm:w-32"
                              options={countryLookupList} // Use the fetched country options
                              value={
                                countryLookupList.find(
                                  (option) => option.value === contact.countryID
                                ) || null
                              }
                              onChange={(e) =>
                                handleInputChange(index, "countryID", e.value)
                              }
                              placeholder="Select"
                            />
                            <div className="flex-grow pl-2">
                              <input
                                type="text"
                                className="w-full p-2 border-l border-gray-300 focus:outline-none"
                                placeholder="Enter phone number"
                                value={contact.phoneNumber}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "phoneNumber",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>

                          {requireErrorMessage &&
                          (contact.phoneNumber === "" ||
                            contact.phoneNumber === undefined ||
                            contact.phoneNumber === null ||
                            contact.countryID === "" ||
                            contact.countryID === undefined ||
                            contact.countryID === null) ? (
                            <label className="validation">
                              {ERROR_MESSAGES}
                            </label>
                          ) : contact.phoneNumber &&
                            contact.phoneNumber?.length < 10 ? (
                            <label className="validation">Invalid Number</label>
                          ) : (
                            ""
                          )}
                        </div>

                        <div>
                          <label className="block text-gray-700 text-12 mb-1">
                            Email <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={contact.email}
                            onChange={(e) =>
                              handleInputChange(index, "email", e.target.value)
                            }
                            className="w-full p-2 border rounded-md text-12"
                          />
                          {requireErrorMessage &&
                          (contact.email === "" ||
                            contact.email === undefined ||
                            contact.email === null) ? (
                            <label className="validation">
                              {ERROR_MESSAGES}
                            </label>
                          ) : (
                            contact.email?.length > 0 &&
                            !validateEmail(contact.email) && (
                              <label className="validation text-red-500 text-sm">
                                Invalid email format
                              </label>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="flex justify-end space-x-2 mb-3">
                <button
                  onClick={() => navigate("/customer")}
                  className="mx-2 px-4 py-2 bg-gray-300 rounded-md text-12 mb-5"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleChangeNext(2)}
                  className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12 mb-5"
                >
                  Next
                </button>
              </div>
            </>
          )}

          {activeTab === 2 && (
            <>
              <div className="bg-white shadow-lg ring-1 ring-gray-300 rounded-2xl p-6">
                <h3 className="text-12 font-semibold mb-4">Services</h3>
                <div className="w-full overflow-x-auto">
                  <div className="flex-1 overflow-y-auto">
                    <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                      <thead>
                        <tr className="z-1 sticky top-0 bg-white">
                          <th className="text-12 border-b border-slate-200 bg-slate-50 text-center whitespace-nowrap p-1">
                            Select
                          </th>
                          <th className="text-12 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap p-1">
                            Service Name
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {serviceOptions.length > 0 ? (
                          serviceOptions.map((service, index) => (
                            <tr
                              key={index}
                              className="hover:bg-slate-50 border-b border-slate-200 text-center"
                            >
                              <td className="whitespace-nowrap text-left p-1 text-center">
                                <input
                                  type="checkbox"
                                  checked={selectedServices[index]} // Ensure this reflects the state
                                  onChange={() => handleCheckboxChange(index)}
                                  className="form-check-input new_input cursor-pointer"
                                />
                              </td>
                              <td className="whitespace-nowrap text-left p-1">
                                {service.label}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2" className="text-center p-4">
                              No services found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {showServiceError && (
                      <label className="validation">
                        Please select at least one service
                      </label>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mb-3 mt-3">
                {/* Back Button (Left Side) */}
                <button
                  onClick={() => setActiveTab(1)}
                  className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12 mb-5"
                >
                  Back
                </button>

                {/* Cancel & Next Buttons (Right Side) */}
                <div className="flex space-x-2">
                  <button
                    onClick={() => navigate("/customer")}
                    className="mx-2 px-4 py-2 bg-gray-300 rounded-md text-12 mb-5"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleChangeNext(4)}
                    className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12 mb-5"
                  >
                    Next
                  </button>
                </div>
              </div>
            </>
          )}

          {activeTab === 3 && (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {/* Card Component */}
                {[
                  {
                    price: "₹0/14 Days Free",
                    features: [
                      "✔ Access to all features",
                      "❌ Priority support",
                      "❌ 100GB storage",
                      "✔ Total Users: 1",
                      "✔ Total Customers: 3",
                      "✔ Timesheet Access: Limited",
                      "✔ Document Storage: 10GB",
                    ],
                    buttonText: "Start Free Trial",
                  },
                  {
                    price: "₹499/Month",
                    features: [
                      "✔ Access to all features",
                      "✔ Priority support",
                      "❌ 100GB storage",
                      "✔ Total Users: 5",
                      "❌ Total Customers: 10",
                      "✔ Timesheet Access: Unlimited",
                      "✔ Document Storage: 50GB",
                    ],
                    buttonText: "Choose Plan",
                  },
                  {
                    price: "₹999/Month",
                    features: [
                      "✔ Access to all features",
                      "✔ Priority support",
                      "❌ 1TB storage",
                      "✔ Total Users: Unlimited",
                      "✔ Total Customers: Unlimited",
                      "✔ Timesheet Access: Unlimited",
                      "✔ Document Storage: Unlimited",
                    ],
                    buttonText: "Choose Plan",
                  },
                  {
                    price: "₹1499/Month",
                    features: [
                      "❌ Access to all features",
                      "✔ Priority support",
                      "❌ 2TB storage",
                      "✔ Total Users: Unlimited",
                      "✔ Total Customers: Unlimited",
                      "❌ Timesheet Access: Unlimited",
                      "✔ Document Storage: Unlimited",
                    ],
                    buttonText: "Choose Plan",
                  },
                ].map((plan, index) => (
                  <div
                    key={index}
                    className="bg-white border rounded-lg shadow-md p-4 flex flex-col justify-between"
                  >
                    <div>
                      <h6 className="text-xl font-bold mb-2">{plan.price}</h6>
                      <p className="text-gray-700 mb-4">
                        {plan.features.map((feature, i) => (
                          <span key={i} className="block">
                            {feature}
                          </span>
                        ))}
                      </p>
                    </div>
                    {/* Button - Aligned at Bottom */}
                    <div className="mt-auto">
                      <a
                        href="#"
                        className="block text-center text-white bg-[#E86B1B] rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                      >
                        {plan.buttonText}
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex justify-between items-center mb-3 mt-3">
                {/* Back Button (Left Side) */}
                <button
                  onClick={() => setActiveTab(2)}
                  className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12 mb-5"
                >
                  Back
                </button>

                {/* Cancel & Next Buttons (Right Side) */}
                <div className="flex space-x-2">
                  <button
                    onClick={() => navigate("/Customer")}
                    className="mx-2 px-4 py-2 bg-gray-300 rounded-md text-12 mb-5"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => setActiveTab(4)}
                    className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12 mb-5"
                  >
                    Next
                  </button>
                </div>
              </div>
            </>
          )}

          {activeTab === 4 && (
            <>
              <PaperWork
                ModuleName={moduleName}
                customerKeyID={location.state?.KeyID}
              />
              <div className="flex justify-between items-center mb-3 mt-3">
                {/* Back Button (Left Side) */}
                <button
                  onClick={() => setActiveTab(3)}
                  className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12 mb-5"
                >
                  Back
                </button>

                {/* Cancel & Next Buttons (Right Side) */}
                <div className="flex space-x-2">
                  <button
                    onClick={() => navigate("/customer")}
                    className="px-4 py-2 bg-gray-300 rounded-md mx-2 mb-5"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSubmit} // Call the handleSubmit function
                    className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12 mb-5"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {/* <SuccessModal
        isOpen={showSuccessPopupModal}
        onClose={() => setShowSuccessPopupModal(false)} // Close the modal
        actionMessage={"Customer"}
        onSuccess={() => navigate("/customer")} // Navigate to /customer on success
      /> */}
      <SuccessModal
        isOpen={showSuccessPopupModal}
        onClose={() => {
          setShowSuccessPopupModal(false);
        }}
        modelAction={modelAction}
        actionMessage={"Customer"}
        onSuccess={() => navigate("/customer")} // Navigate to /customer on success
      />

      <ErrorModal
        isOpen={isErrorOpen}
        onClose={() => setIsErrorOpen(false)}
        errorMessage={errorMessage}
      />
    </>
  );
};

export default AddUpdateCustomer;
